import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { CurbLinkRecord } from "../../interfaces/CurbLink";
import { CurbRegulationRecord } from "../../interfaces/CurbRegulation";
import { Geometry, GeoserverLinkProperties } from "../../interfaces/Geoserver";
export const STORE_CURB_LINKS = "STORE_CURB_LINKS";
export const STORE_IS_IFRAME_VIEW = "STORE_IS_IFRAME_VIEW";
export const STORE_CURB_REGULATIONS = "STORE_CURB_REGULATIONS";
export const SET_IS_GEOSERVER_ENABLED = "SET_IS_GEOSERVER_ENABLED";
export const CURRENT_APPLICATION_VERSION = "CURRENT_APPLICATION_VERSION";
export const STORE_DICTIONARY_CURB_LINKS_AND_REGULATIONS =
    "STORE_DICTIONARY_CURB_LINKS_AND_REGULATIONS";
export const STORE_GEOSERVER_CURB_REGULATIONS = "STORE_GEOSERVER_CURB_REGULATIONS";

export type curbLinks = { [curbLinkId: string]: CurbLinkRecord };
export type curbRegulations = CurbRegulationRecord;
export type geoserverCurbRegulations = { [props: number]: number };

export interface StoreCurbLinksAction {
    type: typeof STORE_CURB_LINKS;
    payload: { curbLinks: curbLinks };
}

export interface StoreCurbRegulationsAction {
    type: typeof STORE_CURB_REGULATIONS;
    payload: { curbRegulations: curbRegulations };
}

export interface SetIsGeoserverEnabledAction {
    type: typeof SET_IS_GEOSERVER_ENABLED;
    payload: { isGeoserverEnabled: boolean };
}

export interface CreateDictionaryLinksAndRegulations {
    [id: number]: DictionaryType;
}

export interface CurrentApplicationVersionAction {
    type: typeof CURRENT_APPLICATION_VERSION;
    payload: { currentApplicationVersion: string };
}

export interface StoreCurbLinksAndRegulationsAction {
    type: typeof STORE_DICTIONARY_CURB_LINKS_AND_REGULATIONS;
    payload: { dictionaryLinksAndRegulations: CreateDictionaryLinksAndRegulations };
}

export interface StoreIsIframeViewAction {
    type: typeof STORE_IS_IFRAME_VIEW;
    payload: { isIframeView: boolean };
}

export interface StoreGeoserverCurbRegulationsAction {
    type: typeof STORE_GEOSERVER_CURB_REGULATIONS;
    payload: { curbRegulations: geoserverCurbRegulations };
}

export type GlobalTypes =
    | SetIsGeoserverEnabledAction
    | StoreCurbLinksAction
    | StoreCurbLinksAndRegulationsAction
    | StoreCurbRegulationsAction
    | ResetStateAction
    | StoreGeoserverCurbRegulationsAction;

export interface GlobalState {
    dictionaryCurbLinks: curbLinks;
    isIframeView: boolean | null;
    dictionaryCurbRegulations: curbRegulations;
    dictionaryLinksAndRegulations: CreateDictionaryLinksAndRegulations;
    isGeoserverEnabled: boolean;
    currentApplicationVersion: string;
    geoserverCurbRegulations: geoserverCurbRegulations;
}

export interface DictionaryType extends GeoserverLinkProperties {
    geometry: Geometry;
}
